import * as filterActions from "../shared/actions/filters";
import { SWITCH_TO_PARAMETER_DETAIL, BREADCRUMBS_CLICK_OVERVIEW } from "./actions/focus_view";

// apply filter when focusing regulation view
export const applyRegulationStandardsListFilter = store => next => action => {
  if (action.type === SWITCH_TO_PARAMETER_DETAIL) {
    const parameterId = action.payload.parameter.id;
    const countryId = action.payload.country.id;

    store.dispatch(filterActions.focusParameterAndCountryId({ parameterId, countryId }));
  } else if (action.type === BREADCRUMBS_CLICK_OVERVIEW) {
    const result = next(action);
    store.dispatch(filterActions.resetParameterAndCountryId({}));
    return result;
  }

  return next(action);
};
